import Box from 'components/shared/Box'
import OrderedTicket from 'components/shared/OrderedTicket'
import Text from 'components/shared/Text'
import { useMemo, useState } from 'react'
import { Color } from 'styles/types'
import BundleEditor from 'routes/selfcare/views/ManageOrder/editors/BundleEditor'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import { FormattedMessage } from 'react-intl'
import { TicketBundleReservation } from 'store/selfcare-slice/types'

interface ManagedBundleProps {
    bundle: TicketBundleReservation
    index: number
}

const BundleTicket = ({ bundle, index }: ManagedBundleProps) => {
    const { deleteItem, revertDeleteItem } = useSelfcare()

    const [isEdited, setIsEdited] = useState(false)

    const { original, changeType, changes, isActive, modificationId } = bundle
    // const dataToDisplay = changes || original
    // TODO: ask BE to fix descriptions and name in changed positions - missing when bundle returned
    // below lines as temporary fix
    const dataToDisplay = {
        ...(changes ? changes : original),
        name: original.name,
        descriptions: original.descriptions,
    }

    const { detail, price, name, descriptions } = dataToDisplay || {}
    const { date, orderBundleId } = detail || {}

    const nameColor: Color = useMemo(() => {
        if (!isActive || changeType === 'return') return 'grayscale_700'
        if (changeType === 'change') return 'primary_500'
        return 'grayscale_900'
    }, [isActive, changeType])

    const descriptionColor: Color = useMemo(() => {
        if (!isActive || changeType === 'return') return 'grayscale_700'
        if (changeType === 'change') return 'primary_500'
        return 'grayscale_700'
    }, [isActive, changeType])

    const bundleText = useMemo(() => {
        const description =
            descriptions && descriptions.length
                ? descriptions[0].description || ''
                : ''
        const dividedDescription = description.split('(').join('<br>(')

        return (
            <Box direction="column">
                <Text variant="bodySmall" color={nameColor} mb={4}>
                    {name}
                </Text>
                <Text
                    variant="bodySmall"
                    color={descriptionColor}
                    dangerouslySetInnerHTML={{
                        __html: dividedDescription,
                    }}
                />
            </Box>
        )
    }, [date, nameColor, descriptionColor, name, descriptions])

    const handleDelete = () => {
        if (!orderBundleId) return

        deleteItem({ productType: 'bundle', detail: { orderBundleId } }).then(
            () => setIsEdited(false)
        )
    }

    const handleRevert = () => {
        if (!modificationId) return

        revertDeleteItem(modificationId)
    }

    const handleCancel = () => setIsEdited(false)

    return (
        <OrderedTicket
            key={orderBundleId}
            id={orderBundleId || ''}
            items={[
                {
                    text: bundleText,
                },
            ]}
            price={price || 0}
            onDelete={handleDelete}
            isEdited={isEdited}
            setIsEdited={setIsEdited}
            isDisabled={!isActive}
            creator={
                <BundleEditor
                    bundle={bundle}
                    onCancel={handleCancel}
                    index={index}
                />
            }
            isDeleted={isActive && changeType === 'return'}
            onRevert={handleRevert}
            testIdPrefix={`selfcare-bundle-${index}`}
            previewAlign="flex-start"
            restoreBtnLabel={
                <FormattedMessage
                    id="global.btn.revert_tickets"
                    defaultMessage="Przywróć bilety"
                />
            }
            hasUnwrappedDescriptionOnMobile
        />
    )
}
export default BundleTicket
